export type UserAgentInfo = {
  name: string;
  version: string;
  platform: string;
};

export function parseUserAgent(userAgent: string): UserAgentInfo {
  const browserMatch = userAgent.match(/(Chrome|Firefox|Safari|Edge|Edg|Opera|OPR)\/([\d.]+)/);
  const platformMatch = userAgent.match(/\(([^)]+)\)/);

  return {
    name: browserMatch?.[1] === 'Edg' ? 'Edge' : (browserMatch?.[1] ?? 'Unknown'),
    version: browserMatch?.[2] ?? 'Unknown',
    platform: platformMatch?.[1] ?? 'Unknown',
  };
}
